import UltMeta, { Meta } from "./UltMeta/index";

// 额度变更

/**
 * 变更方向
 */
class ChangeType extends UltMeta {
    ADD = new Meta(1, "增加");
    SUBTRACT = new Meta(2, "减少");
    PURPOSE_CHANGE = new Meta(3, "用途变更");
}

export const CHANGE_TYPE = new ChangeType();

/**
 * 变更类型  供应链端
 */
class QuotaType extends UltMeta {
    BUY = new Meta(1, "采购变更");
    SELL = new Meta(2, "销售变更");
}

export const QUOTA_TYPE = new QuotaType();

/**
 * 变更类型  客户端  供应链端和客户端这个枚举值一样，label相反
 */
class QuotaTypeCustom extends UltMeta {
    SELL = new Meta(1, "销售变更");
    BUY = new Meta(2, "采购变更");
}

export const QUOTA_TYPE_CUSTOM = new QuotaTypeCustom();

/**
 * 费用类型
 */
class CostType extends UltMeta {
    GOODS_PAYMENT = new Meta(1, "货款");
    BOND = new Meta(2, "履约保证金");
    BOND_TO_PAYMENT = new Meta(3, "履约保证金转货款");
    PAYMENT_TO_BOND = new Meta(4, "货款转履约保证金");
}

export const COST_TYPE = new CostType();

/**
 * 列表筛选状态
 */
class QueryState extends UltMeta {
    CONFIRMING = new Meta(1, "确认中");
    TO_BE_CONFIRMED = new Meta(2, "待确认");
    COMPLETED = new Meta(3, "变更完成");
    REJECTED = new Meta(4, "已驳回");
}

export const QUERY_STATE = new QueryState();

// 己方视角的状态
class SelfState extends UltMeta {
    CONFIRMING = new Meta(1, "确认中");
    // 已驳回，后端数据会过滤掉
    REJECTED = new Meta(2, "已驳回");
    COMPLETED = new Meta(3, "变更完成");
}
export const SELF_STATE = new SelfState();

// 对方视角的状态
class OtherState extends UltMeta {
    TO_BE_CONFIRMED = new Meta(1, "待确认");
    REJECTED = new Meta(2, "已驳回");
    COMPLETED = new Meta(3, "变更完成");
}
export const OTHER_STATE = new OtherState();
